import Login from "../pages/Auth/Login";
import CandidateAccess from "../pages/Candidate/CandidateAccess/CandidateAccess";
import CandidateDeviceCheck from "../pages/Candidate/CandidateDeviceCheck/CandidateDeviceCheck";
import CandidateDisclaimer from "../pages/Candidate/CandidateDisclaimer/CandidateDisclaimer";
import Interview from "../pages/Candidate/Interview/Interview";
import InterviewCompletion from "../pages/Candidate/InterviewCompletion/InterviewCompletion";
import ViewRecording from "../pages/ViewRecording";
import ProtectPublicRoutes from "./ProtectRoutes/ProtectPublicRoutes";
import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const VIEW_RECORDING_RETURN_TO_KEY = "viewRecordingReturnTo";
const VIEW_RECORDING_VIEW_ONLY_KEY = "viewRecordingViewOnly";
const VIEW_RECORDING_ALLOWED_PATH_KEY = "viewRecordingAllowedPath";

const ViewRecordingAuthGate = () => {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  const isInAppNavigation = !!location.state?.candidate;
  if (isInAppNavigation) {
    // existing app navigation flow — do not enforce view-only mode
    return <ViewRecording />;
  }

  const returnTo = `${location.pathname}${location.search}${location.hash}`;

  // Enforce "view only" within this tab/session (doesn't affect other tabs)
  try {
    window.sessionStorage.setItem(VIEW_RECORDING_VIEW_ONLY_KEY, "true");
    window.sessionStorage.setItem(VIEW_RECORDING_ALLOWED_PATH_KEY, returnTo);
  } catch (e) {}

  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  if (!isAuthenticated) {
    // Persist across SSO redirect; cleared after consumption
    try {
      window.localStorage.setItem(VIEW_RECORDING_RETURN_TO_KEY, returnTo);
    } catch (e) {}
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <ViewRecording />;
};

export const publicRoutes = [
  {
    path: "/",
    element: (
      <ProtectPublicRoutes>
        <Login />,
      </ProtectPublicRoutes>
    ),
  },

  {
    path: "/candidate-access",
    element: <CandidateAccess />,
  },
  {
    path: "/candidate-disclaimer/:token",
    element: <CandidateDisclaimer />,
  },

  {
    path: "/device-check/:token",
    element: <CandidateDeviceCheck />,
  },
  // {
  //   path: "/candidate-disclaimer/:interviewId",
  //   element: <CandidateDisclaimer />,
  // },

  // {
  //   path: "/device-check/:interviewId",
  //   element: <CandidateDeviceCheck />,
  // },

  {
    path: "/interview",
    element: <Interview />,
  },
  {
    path: "/interview/:token",
    element: <Interview />,
  },

  {
    path: "/interview-completion/:interviewId",
    element: <InterviewCompletion />,
  },
  // Public read-only view of interview recording (shareable link for managers)
  {
    path: "/view-recording/:id",
    element: <ViewRecordingAuthGate />,
  },
];
